import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ApiClient from "../../api-client";
import { apiUrl, PORT } from "../../environment";
import { toasterConfig } from "../../utils/constants";
toast.configure();


export const getAssignmentSectionCounts = (params, callback) => {
    let localStartDate = new Date();
      localStartDate.setDate(localStartDate.getDate() - 7);

      let utcStartOfDay = new Date(localStartDate.getFullYear(), localStartDate.getMonth(), localStartDate.getDate(), 0, 0, 0);
      let startDate = new Date(utcStartOfDay.getTime()); // Subtracting UTC offset
      startDate = (startDate).toISOString();

      // Convert end date to UTC
      let localEndDate = new Date();
      let utcEndOfDay = new Date(localEndDate.getFullYear(), localEndDate.getMonth(), localEndDate.getDate(), 23, 59, 59, 999);
      let endDate = new Date(utcEndOfDay.getTime()); // Subtracting UTC offset
      endDate = (endDate).toISOString();
      params = { startDate, endDate, ...params };
    return (dispatch, getState) => {
        const { user: { token } } = getState();

        if (!params.startDate || !params.endDate) {
            let localStartDate = new Date();
            localStartDate.setDate(localStartDate.getDate() - 7);
       
            let utcStartOfDay = new Date(localStartDate.getFullYear(), localStartDate.getMonth(), localStartDate.getDate(), 0, 0, 0);
            let startDate = new Date(utcStartOfDay.getTime()); // Subtracting UTC offset
            startDate = (startDate).toISOString();
       
            // Convert end date to UTC
            let localEndDate = new Date();
            let utcEndOfDay = new Date(localEndDate.getFullYear(), localEndDate.getMonth(), localEndDate.getDate(), 23, 59, 59, 999);
            let endDate = new Date(utcEndOfDay.getTime()); // Subtracting UTC offset
            endDate = (endDate).toISOString();
            params = {  startDate, endDate, ...params };
          }




        // dispatch({ type: "ISLOADING", data: true });
        ApiClient.get(`${apiUrl}${PORT}/dashboardStats/assignmentQueueSection`, params, token, dispatch).then(
            (response) => {
                // dispatch({ type: "ISLOADING", data: false });
                if (response && !response.errors) {
                    callback && callback(response)
                } else if (response.code === 404) {
                    toast.error(response.message);
                    callback && callback(false)
                } else {
                    toast.error(response.errors.msg, toasterConfig);
                    callback && callback(false)
                }
            }
        );
    };
};

export const getOrganizationsLatestUploads = (callback) => {
    return (dispatch, getState) => {
        const { user: { token } } = getState();
        // dispatch({ type: "ISLOADING", data: true });
        ApiClient.get(`${apiUrl}${PORT}/organization/getOrganizationsLatestUploads`,{}, token, dispatch).then(
            (response) => {
                console.log("sdaawew", response)
                // dispatch({ type: "ISLOADING", data: false });
                if (response && !response.errors) {
                    callback && callback(response)
                } else if (response.code === 404) {
                    toast.warn(response.message);
                    callback && callback(false)
                } else {
                    toast.error(response.errors.msg, toasterConfig);
                    callback && callback(false)
                }
            }
        );
    };
}

export const fileUploadStats = (params, callback) => {
    return (dispatch, getState) => {
        const { user: { token } } = getState();
        // dispatch({ type: "ISLOADING", data: true });
        ApiClient.get(`${apiUrl}${PORT}/dashboardStats/fileUploadStats`, params, token, dispatch).then(
            (response) => {
                // dispatch({ type: "ISLOADING", data: false });
                if (response && !response.errors) {
                    callback && callback(response)
                } else if (response.code === 404) {
                    toast.warn(response.message);
                    callback && callback(false)
                } else {
                    toast.error(response.errors.msg, toasterConfig);
                    callback && callback(false)
                }
            }
        );
    };
};

export const fileCompleteChartStats = (params, callback) => {
    return (dispatch, getState) => {
        const { user: { token } } = getState();
        // dispatch({ type: "ISLOADING", data: true });
        ApiClient.get(`${apiUrl}${PORT}/dashboardStats/fileCompletionOnWeek`, params, token, dispatch).then(
            (response) => {
                // dispatch({ type: "ISLOADING", data: false });
                if (response && !response.errors) {
                    callback && callback(response)
                } else if (response.code === 404) {
                    toast.warn(response.message);
                    callback && callback(false)
                } else {
                    toast.error(response.errors.msg, toasterConfig);
                    callback && callback(false)
                }
            }
        );
    };
};

export const fileCandleChartData = (params, callback) => {
    return (dispatch, getState) => {
        const { user: { token } } = getState();
        // dispatch({ type: "ISLOADING", data: true });
        ApiClient.get(`${apiUrl}${PORT}/dashboardStats/fileCandleChartData`, params, token, dispatch).then(
            (response) => {
                // dispatch({ type: "ISLOADING", data: false });
                if (response && !response.errors) {
                    callback && callback(response)
                } else if (response.code === 404) {
                    toast.warn(response.message);
                    callback && callback(false)
                } else {
                    toast.error(response.errors.msg, toasterConfig);
                    callback && callback(false)
                }
            }
        );
    };
};

export const fileProcessedStats = (params, callback) => {
    return (dispatch, getState) => {
        const { user: { token } } = getState();
        // dispatch({ type: "ISLOADING", data: true });
        ApiClient.get(`${apiUrl}${PORT}/dashboardStats/fileProcessed`, params, token, dispatch).then(
            (response) => {
                // dispatch({ type: "ISLOADING", data: false });
                if (response && !response.errors) {
                    callback && callback(response)
                } else if (response.code === 404) {
                    toast.warn(response.message);
                    callback && callback(false)
                } else {
                    toast.error(response.errors.msg, toasterConfig);
                    callback && callback(false)
                }
            }
        );
    };
};

export const fileUploadedChartStats = (params, callback) => {
    return (dispatch, getState) => {
        const { user: { token } } = getState();
        // dispatch({ type: "ISLOADING", data: true });
        ApiClient.get(`${apiUrl}${PORT}/dashboardStats/fileUploadedOnWeek`, params, token, dispatch).then(
            (response) => {
                // dispatch({ type: "ISLOADING", data: false });
                if (response && !response.errors) {
                    callback && callback(response)
                } else if (response.code === 404) {
                    toast.warn(response.message);
                    callback && callback(false)
                } else {
                    toast.error(response.errors.msg, toasterConfig);
                    callback && callback(false)
                }
            }
        );
    };
};


export const errorWatchLogs = (params, callback) => {
    return (dispatch, getState) => {
      const {
        user: { token },
      } = getState();
      ApiClient.get(
        `${apiUrl}${PORT}/errorWatch`,
        params,
        token,
        dispatch
      ).then((response) => {
        if (response && !response.errors) {
          callback(response);
        } else if (response.code === 404) {
          toast.error(response.message);
        } else {
          toast.error(response.errors.msg, toasterConfig);
        }
      });
    };
  };

